import { render, staticRenderFns } from "./modal_zugriffsrechte.vue?vue&type=template&id=7c96cca4&scoped=true&"
import script from "./modal_zugriffsrechte.vue?vue&type=script&lang=js&"
export * from "./modal_zugriffsrechte.vue?vue&type=script&lang=js&"
import style0 from "./modal_zugriffsrechte.vue?vue&type=style&index=0&id=7c96cca4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c96cca4",
  null
  
)

export default component.exports